var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M37.5,38.7c0.4,2.7-2.4,4.7-4.9,3.5L25,38.3c-0.6-0.3-1.4-0.3-2.1,0l-7.6,3.9c-2.4,1.3-5.3-0.8-4.9-3.5l1.3-8.7 c0.1-0.7-0.1-1.4-0.6-1.9l-5.8-5.8c-1.9-1.9-0.9-5.3,1.9-5.7l4.4-0.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M17.6,14.1L21,7.2c1.2-2.5,4.8-2.5,6,0l3.4,6.8c0.3,0.6,0.9,1.1,1.7,1.2l8.7,1.3c2.7,0.4,3.8,3.7,1.9,5.7 l-5.8,5.8c-0.5,0.5-0.7,1.2-0.6,1.9l0.4,2.6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.c03ed8a3ba409be273917552cf1eb690.svg";
export { ForwardRef as ReactComponent };